var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'player_chat_unblock', params: {playerId: _vm.playerId, chatUnblockId: _vm.chatUnblockId}}}},[_vm._v("\n  "+_vm._s(_vm.lable)+" "+_vm._s(_vm.chatUnblockId)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }